'use client';

import { useState, useEffect } from 'react';
import { useAtom } from 'jotai';
import { delegatesAtom } from '@/app/atoms/delegates';

const useDelegatesLoading = () => {
  const [delegates] = useAtom(delegatesAtom);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (delegates.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [delegates]);

  return { delegates, loading };
};

export default useDelegatesLoading;
